import React from "react";
import Render from "@gqlapp/theme";
import navigation from "../templates/navigation.html.twig";

export default function NavigationBlock(props: any){
	return <Render template={navigation} context={{ mainMenu: Array.isArray(props?.mainMenu) ? props.mainMenu : [] }} />;
}
